import '.d{display:flex;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.ft{padding:0.75rem;}.ssr-plugin'
import '.at{border-radius:1.25rem;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.dv{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fu{width:2.5rem;}.ssr-plugin'
import '.cj{height:2.5rem;}.ssr-plugin'
import '.fv{color:var(--palette-blue-700);}.ssr-plugin'
import '.fw{font-size:0.9rem;}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d ab e r s z ft at u t dv"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fu cj d r ab fv"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="fw fv a5"
        >
          {label}
        </span>
      </styled.button>
    )
}